// Mock data para Mind Life Centro Psicológico

export const services = [
  {
    id: 1,
    title: "Terapia Individual",
    description: "Atención personalizada para adultos, adolescentes y niños. Tratamiento de ansiedad, depresión, estrés y otros trastornos emocionales.",
    icon: "user",
    category: "terapia"
  },
  {
    id: 2,
    title: "Terapia de Pareja",
    description: "Fortalecimiento de vínculos, resolución de conflictos y mejora de la comunicación en las relaciones de pareja.",
    icon: "heart",
    category: "terapia"
  },
  {
    id: 3,
    title: "Terapia Familiar",
    description: "Abordaje sistémico para resolver conflictos familiares y mejorar la dinámica del hogar.",
    icon: "users",
    category: "terapia"
  },
  {
    id: 4,
    title: "Psicología Infantil y Adolescente",
    description: "Tratamiento especializado en trastornos del neurodesarrollo, problemas de conducta y aprendizaje.",
    icon: "baby",
    category: "infantil"
  },
  {
    id: 5,
    title: "Evaluaciones Psicológicas",
    description: "Evaluaciones completas para diagnóstico de trastornos emocionales, cognitivos y de personalidad.",
    icon: "clipboard-list",
    category: "evaluacion"
  },
  {
    id: 6,
    title: "Neuropsicología",
    description: "Evaluación y tratamiento de trastornos cognitivos, TDAH, autismo, dislexia y otras condiciones neuropsicológicas.",
    icon: "brain",
    category: "neuropsicologia"
  },
  {
    id: 7,
    title: "Interconsultas Psiquiátricas",
    description: "Atención médica especializada en salud mental con prescripción de tratamiento farmacológico cuando sea necesario.",
    icon: "stethoscope",
    category: "psiquiatria"
  },
  {
    id: 8,
    title: "Talleres y Grupos de Apoyo",
    description: "Espacios grupales para el desarrollo de habilidades emocionales y sociales.",
    icon: "users-round",
    category: "talleres"
  }
];

export const team = [
  {
    id: 1,
    name: "Lic. José Luis Riojas Luna",
    registration: "C.Ps.P N° 27935",
    photo: "https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=400&h=400&fit=crop",
    specialties: [
      "Psicoterapia Cognitivo Conductual",
      "Tratamiento en trastornos de personalidad",
      "Hipnosis clínica",
      "Terapia de modificación de conducta en niños y adolescentes",
      "Terapia familiares y de pareja",
      "Psicología Forense",
      "Consultor en Psicología Organizacional"
    ],
    type: "psicologo"
  },
  {
    id: 2,
    name: "Lic. Rocío del Carmen Alarcón",
    registration: "C.Ps.P N° 31419",
    photo: "https://images.unsplash.com/photo-1594824476967-48c8b964273f?w=400&h=400&fit=crop",
    specialties: [
      "Psicoterapia Cognitivo Conductual",
      "Terapia Racional Emotiva (TREC)",
      "Atención a pacientes mediante lenguaje de señas",
      "Psicoterapia en temas de Violencia Familiar",
      "Consejería en procesos emocionales sobre Infertilidad",
      "Psicología del Adulto Mayor"
    ],
    type: "psicologo"
  },
  {
    id: 3,
    name: "Lic. Ismelda Peña López",
    registration: "C.Ps.P N° 32826",
    photo: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=400&fit=crop",
    specialties: [
      "Terapia Cognitivo Conductual",
      "Terapia de Pareja y Familia con enfoque Sistémico",
      "Terapia Activación Conductual: Depresión / Adultos",
      "Especialista en Neuropsicología",
      "Trastornos del Neurodesarrollo: TDAH, Autismo, Dislexia",
      "Problemas de conducta y aprendizaje"
    ],
    type: "psicologo"
  },
  {
    id: 4,
    name: "Lic. Graciela Jara Ramirez",
    registration: "C.Ps.P N° 37860",
    photo: "https://images.unsplash.com/photo-1551836022-d5d88e9218df?w=400&h=400&fit=crop",
    specialties: [
      "Psicoterapeuta Cognitivo Conductual Emotivo (TREC)",
      "Especialidad en trastornos del neurodesarrollo TEA",
      "Modificación de conducta y psicoeducación",
      "Trastornos de la conducta alimentaria",
      "Terapia Dialéctica Conductual (DBT)"
    ],
    type: "psicologo"
  },
  {
    id: 5,
    name: "Lic. Laura Cruz",
    registration: "C.Ps.P N° 31258",
    photo: "https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=400&h=400&fit=crop",
    specialties: [
      "Psicoterapeuta cognitivo conductual",
      "Intervención temprana en niños",
      "Maestría en psicología clínica con mención en neuropsicología"
    ],
    type: "psicologo"
  },
  {
    id: 6,
    name: "Dr. Alex Alberto Rázuri",
    registration: "C.M.P. 68519 | R.N.E. 40464",
    photo: "https://images.unsplash.com/photo-1622253692010-333f2da6031d?w=400&h=400&fit=crop",
    specialties: [
      "Médico Psiquiatra",
      "Jefe del Centro de Salud Mental Comunitaria",
      "Tratamiento farmacológico especializado",
      "Atención en trastornos psiquiátricos complejos"
    ],
    type: "psiquiatra"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "María G.",
    text: "La atención que recibí fue excepcional. Me ayudaron a superar mi ansiedad y ahora tengo herramientas para manejar el estrés diario.",
    rating: 5
  },
  {
    id: 2,
    name: "Carlos R.",
    text: "El equipo de Mind Life es muy profesional. La terapia de pareja salvó mi relación. Totalmente recomendado.",
    rating: 5
  },
  {
    id: 3,
    name: "Ana L.",
    text: "Mi hijo ha mejorado muchísimo con la terapia infantil. Las psicólogas son muy cálidas y profesionales.",
    rating: 5
  }
];

export const faqs = [
  {
    id: 1,
    question: "¿Cuánto dura una sesión de terapia?",
    answer: "Cada sesión tiene una duración aproximada de 45 a 60 minutos, dependiendo del tipo de terapia y las necesidades del paciente."
  },
  {
    id: 2,
    question: "¿Cómo puedo agendar una cita?",
    answer: "Puedes agendar tu cita escribiéndonos por WhatsApp al 934 442 759. Nuestro equipo te responderá a la brevedad para coordinar el horario que mejor se ajuste a tus necesidades."
  },
  {
    id: 3,
    question: "¿Ofrecen terapia online?",
    answer: "Sí, ofrecemos sesiones de terapia online a través de videollamada para mayor comodidad de nuestros pacientes."
  },
  {
    id: 4,
    question: "¿Trabajan con niños y adolescentes?",
    answer: "Sí, contamos con especialistas en psicología infantil y adolescente, así como en neuropsicología para trastornos del neurodesarrollo."
  },
  {
    id: 5,
    question: "¿Las sesiones son confidenciales?",
    answer: "Absolutamente. Toda la información compartida en las sesiones es estrictamente confidencial, siguiendo el código de ética profesional."
  }
];

export const contactInfo = {
  whatsapp: "934442759",
  whatsappDisplay: "934 442 759",
  email: "mindlifeperu@gmail.com",
  address: "Lima, Perú",
  schedule: "Lunes a Sábado: 9:00 AM - 8:00 PM"
};
